var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{staticClass:"gl-align-middle",attrs:{"href":_vm.badgeUrl,"variant":_vm.status,"data-testid":"check-version-badge"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }